import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-proveedor',
  template: `
  <div>
  <router-outlet></router-outlet>
  </div>
  <!-- <app-footer-proveedor></app-footer-proveedor> -->
  `,
  styleUrls: []
})
export class ProveedorComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    console.log("proveedor.component");
  }

}
